import mongoose from 'mongoose';
import provisionCodeCache, { IProvisionCodeCacheDocument } from '../schemas/provision-code-cache';

export default (mongoose.models.ProvisionCodeCache ||
  mongoose.model<IProvisionCodeCacheDocument>(
    'ProvisionCodeCache',
    provisionCodeCache,
  )) as mongoose.Model<IProvisionCodeCacheDocument>;
